/* Eznzza · ficha de producto (PC): la tarjeta de información tiene su propio
   scroll. Cuando llega al final (o al principio), la rueda del mouse sigue
   moviendo la página, sin que se trabe en la tarjeta. */
(function () {
  if (window.__ezPdpScroll) return;
  window.__ezPdpScroll = true;
  function init() {
    var box = document.querySelector('.main-product-section .main-product--grid > .featured-gallery-card + .product-information--wrapper');
    if (!box) return;
    box.addEventListener('wheel', function (e) {
      if (e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      if (box.scrollHeight <= box.clientHeight + 1) return;
      var dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
      var atTop = box.scrollTop <= 0;
      var atBottom = box.scrollTop + box.clientHeight >= box.scrollHeight - 1;
      if ((dy > 0 && atBottom) || (dy < 0 && atTop)) {
        e.preventDefault();
        window.scrollBy(0, dy);
      }
    }, { passive: false });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
